import moment from 'moment';
import { GetAllMeetingsDetailAPIResponse, MeetingStatus, UIMeeting, UIUser } from 'types';

export const canShowJoinCta = (meetingStatus: MeetingStatus) => {
	return [MeetingStatus.SCHEDULED, MeetingStatus.STARTED, MeetingStatus.PENDING].includes(meetingStatus);
};

export const canShowRescheduleCta = (meeting: UIMeeting, user: UIUser | null) => {
	const status = meeting.meetingStatus;
	const startTime = meeting.startTime;
	if (
		[
			MeetingStatus.COMPLETED,
			MeetingStatus.RESCHEDULED,
			MeetingStatus.JOBSEEKERRESCHEDULED,
			MeetingStatus.JOBSEEKERNOSHOW,
			MeetingStatus.STARTED,
			MeetingStatus.MENTORNOSHOW,
		].includes(status) ||
		user?.flags?.isMasaiStudent ||
		meeting.isAIInterview
	) {
		return false;
	}
	return moment().isBefore(moment(startTime).subtract(1, 'hour'));
};

export const checkIfAnyMeetingIsScheduled = (meetings: UIMeeting[]) => {
	return meetings.filter(m => [MeetingStatus.SCHEDULED].includes(m.meetingStatus)).length ? true : false;
};

export const isAtLeastOneRecordingAvailable = (data: GetAllMeetingsDetailAPIResponse | undefined) => {
	return !!data?.meetings?.find(m => m.meetingRecordings.length);
};

export const checkMinMaxValidity = (min: number, max: number) => {
	if (min <= max) {
		return true;
	} else {
		return false;
	}
};
